export default __webpack_public_path__ + "static/media/3B.55554e09.png";